import { render, staticRenderFns } from "./CustomFabBtn.vue?vue&type=template&id=2a2afadc&scoped=true&"
import script from "./CustomFabBtn.vue?vue&type=script&lang=js&"
export * from "./CustomFabBtn.vue?vue&type=script&lang=js&"
import style0 from "./CustomFabBtn.vue?vue&type=style&index=0&id=2a2afadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2afadc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
